import { CustomerInvitingPage } from './CustomerInvitingPage';
export default CustomerInvitingPage;
